<template>
  <div id="app-div">
    <div class="top">
      <div class="search_icon">
        <span style="margin-left: 10px">
          <img src="../../../../assets/u3220.png" class="icon_img" />筛选查询
        </span>
      </div>
      <div class="query_div">
        <a-row>
          <a-col :span="5">
            <label>稿件编号：</label>
            <a-input
              placeholder="请输入"
              v-model="queryCode"
              class="query_input"
            />
          </a-col>
          <a-col :span="5">
            <label>标题：</label>
            <a-input
              placeholder="请输入"
              v-model="queryCnTitle"
              class="query_input"
            />
          </a-col>
          <a-col :span="4">
            <label>作者：</label>
            <a-input
              placeholder="请输入"
              v-model="queryAuthorName"
              class="query_input"
            />
          </a-col>
          <a-col :span="4">
            <label>状态：</label>
            <a-select
              defaultValue="0"
              class="query_input"
              v-model="queryStatus"
            >
              <a-select-option value="">全部</a-select-option>
              <a-select-option value="2/-1">未分稿</a-select-option>
              <a-select-option value="2/0">责编未处理</a-select-option>
              <a-select-option value="2/1">未查重</a-select-option>
              <a-select-option value="2/2">已查重（未通过）</a-select-option>
              <a-select-option value="2/3">查重通过</a-select-option>
              <a-select-option value="2/4">已一审</a-select-option>
              <a-select-option value="2/5">已二审</a-select-option>
              <a-select-option value="2/6">已三审</a-select-option>
              <a-select-option value="2/7">专家审稿中</a-select-option>
              <a-select-option value="2/8">专家审稿完成</a-select-option>
              <a-select-option value="2/9">已一校</a-select-option>
              <a-select-option value="2/10">已二校</a-select-option>
              <a-select-option value="2/11">已三校</a-select-option>
              <a-select-option value="33">需退改</a-select-option>
              <a-select-option value="44">需退稿</a-select-option>
              <a-select-option value="5">已录用</a-select-option>
              <a-select-option value="3">已退改</a-select-option>
              <a-select-option value="4">已退稿</a-select-option>
            </a-select>
          </a-col>
          <a-button type="primary" class="query_btn" @click="query">
            查询
          </a-button>
        </a-row>
      </div>
    </div>
    <div class="middle">
      <div style="float: left; margin-left: 10px">
        <img src="../../../../assets/u3227.png" class="icon_img" />
        <span>&nbsp;数据列表</span>
      </div>
      <div class="sortType" style="float: right">
        排序方式：
        <a-select
          size="small"
          defaultValue="1"
          style="width: 120px"
          @change="sortChange"
          v-model="sort"
        >
          <a-select-option value="1">编号降序</a-select-option>
          <a-select-option value="2">编号升序</a-select-option>
          <a-select-option value="3">时间降序</a-select-option>
          <a-select-option value="4">时间升序</a-select-option>
        </a-select>
      </div>
    </div>
    <div class="bottom" id="bottom">
      <div class="table_box">
        <a-table
          :pagination="false"
          :rowSelection="rowSelection"
          :columns="columns"
          :dataSource="data"
          :rowKey="(record) => record.code"
          size="small"
          :scroll="{ y: data.length < 9 ? false : table_height }"
          bordered
        >
          <span
            slot="operator"
            slot-scope="text, record"
            v-if="record.status > 0"
          >
            <a href="javascript:void(0);" @click="() => dealHistory(record)">
              处理历史
            </a>
            <a-divider type="vertical" />
            <a href="javascript:void(0);" @click="() => auditedOpinion(record)">
              审稿意见
            </a>
            <a-divider type="vertical" />
            <a href="javascript:void(0);" @click="() => downLoad(record)">
              下载
            </a>
            <template v-if="record.status == 2">
              <a-divider type="vertical" />
              <a href="javascript:void(0);" @click="() => toBack(record)"
                >撤稿</a
              >
            </template>
          </span>
          <template slot="sort" slot-scope="text, record, index">
            {{ `${(page - 1) * limit + index + 1}` }}
          </template>
          <span slot="code" slot-scope="text, record">
            <label @click="manuscriptsInfo(record)" class="view_manu">{{
              record.code
            }}</label>
          </span>
          <span slot="cnTitle" slot-scope="text, record">
            <a-tooltip placement="topLeft">
              <template slot="title">
                <span>{{ record.cnTitle }}</span>
              </template>
              <div class="shenglue">
                <label @click="preview(record)" class="view_manu">{{
                  record.cnTitle
                }}</label>
              </div>
            </a-tooltip>
          </span>
          <span slot="status" slot-scope="text, record">
            <template v-if="record.status == 2 && record.result == 0">
              <label v-if="record.auditStatus == -1"> 未分稿 </label>
              <label v-if="record.auditStatus == 0"> 责编未处理 </label>
              <label v-if="record.auditStatus == 1"> 未查重 </label>
              <label v-if="record.auditStatus == 2"> 已查重（未通过） </label>
              <label v-if="record.auditStatus == 3"> 查重通过 </label>
              <label v-if="record.auditStatus == 4"> 已一审 </label>
              <label v-if="record.auditStatus == 5"> 已二审 </label>
              <label v-if="record.auditStatus == 6"> 已三审 </label>
              <label v-if="record.auditStatus == 7"> 专家审稿中 </label>
              <label v-if="record.auditStatus == 8"> 专家审稿完成 </label>
              <label v-if="record.auditStatus == 9"> 已一校 </label>
              <label v-if="record.auditStatus == 10"> 已二校 </label>
              <label v-if="record.auditStatus == 11"> 已三校 </label>
            </template>
            <template v-if="record.status == 2">
              <label v-if="record.result == 33"> 需退改 </label>
              <label v-if="record.result == 44"> 需退稿 </label>
            </template>
            <label v-if="record.status == 3">已退改</label>
            <label v-if="record.status == 4">已退稿</label>
            <label v-if="record.status == 5">已录用</label>
          </span>
        </a-table>
      </div>
      <div style="float: right; margin-top: 20px">
        <a-pagination
          :total="total"
          :showTotal="(total) => `共 ${total} 条`"
          showSizeChanger
          showQuickJumper
          :pageSizeOptions="pageSizeOptions"
          :defaultPageSize="limit"
          @showSizeChange="onShowSizeChange"
          @change="pageChange"
        />
      </div>
      <a-select
        defaultValue="0"
        style="float: left; margin-top: 20px"
        @change="operateChange"
        v-model="operateCode"
      >
        <a-select-option value="0">批量操作</a-select-option>
        <a-select-option value="1">批量导出</a-select-option>
      </a-select>
    </div>
    <a-modal
      title="温馨提示"
      v-model="backVisible"
      @ok="backOk"
      :maskClosable="false"
    >
      <p>您是否要撤销此稿件？</p>
    </a-modal>
    <a-modal
      title="处理历史"
      v-model="dealVisible"
      :centered="true"
      width="1000px"
      :footer="null"
      :maskClosable="false"
    >
      <a-table
        :pagination="false"
        :columns="dealColumns"
        :dataSource="dealList"
        :rowKey="(record) => record.dealCode"
        bordered
        size="small"
      ></a-table>
    </a-modal>

    <AuditOpinions ref="auditOpinions" :infoData="manuscript" />

    <ManuscriptInfo ref="manuscriptInfo" :infoData="manuscript" />
  </div>
</template>


<script>
//处理历史
const dealColumns = [
  {
    title: "处理人类型",
    dataIndex: "personType",
  },
  {
    title: "处理时间",
    dataIndex: "dealTime",
  },
  {
    title: "处理类型",
    dataIndex: "dealType",
  },
  {
    title: "处理内容",
    dataIndex: "dealContent",
  },
];
const columns = [
  {
    title: "序号",
    dataIndex: "sort",
    width: 60,
    scopedSlots: { customRender: "sort" },
  },
  {
    title: "稿件编号",
    dataIndex: "",
    width: 130,
    scopedSlots: { customRender: "code" },
  },
  {
    title: "标题",
    dataIndex: "cnTitle",
    scopedSlots: { customRender: "cnTitle" },
  },
  {
    title: "作者",
    width: 90,
    dataIndex: "authorName",
  },
  {
    title: "所在单位",
    dataIndex: "companyName",
  },
  {
    title: "稿件字数",
    width: 90,
    dataIndex: "wordCount",
  },
  {
    title: "投稿时间",
    dataIndex: "createTime",
    width: 160,
  },
  {
    title: "状态",
    dataIndex: "status",
    width: 130,
    scopedSlots: { customRender: "status" },
  },
  {
    title: "操作",
    width: 260,
    key: "action",
    scopedSlots: { customRender: "operator" },
  },
];

import qs from "qs";
import AuditOpinions from "../../../commomon/AuditOpinions.vue";
import ManuscriptInfo from "../../../commomon/ManuscriptInfo.vue";
export default {
  name: "query",
  components: {
    AuditOpinions,
    ManuscriptInfo,
  },
  data() {
    return {
      serviceAddress: this.$config.serviceAddress,
      backVisible: false,
      dealVisible: false,
      manuscript: {},
      data: [],
      columns,
      selectedRowKeys: [],
      queryCode: "",
      queryCnTitle: "",
      queryAuthorName: "",
      queryStatus: "",
      dealList: [],
      dealColumns,
      sort: "1",
      sortField: "code",
      sortType: "desc",
      operateCode: "0",
      page: 1,
      limit: 20,
      total: 0,
      pageSizeOptions: ["10", "20", "30", "40", "50"],
      table_height: 0,
    };
  },
  computed: {
    rowSelection() {
      const { selectedRowKeys } = this;
      return {
        columnWidth: 35,
        selectedRowKeys,
        onChange: this.onSelectChange,
        hideDefaultSelections: true,
        onSelection: this.onSelection,
      };
    },
  },
  created() {
    this.query();
  },
  mounted() {
    //设置bottom高度
    var height = document.body.clientHeight;
    var bottom_height = height - 230;
    var bottom = document.getElementById("bottom");
    bottom.style.height = bottom_height + "px";
    this.table_height = bottom_height - 100;
  },
  methods: {
    //预览稿件
    preview(record) {
      var codes = [];
      codes.push(record.code);
      this.axios
        .post("/manuscriptsAddFile/queryByCode", {
          codes: JSON.stringify(codes),
        })
        .then((res) => {
          if (res.data.code == "OK") {
            var addFile = res.data.data;
            if (addFile.length > 0) {
              this.$router.push({
                path: "/edit/preview",
                query: { fileCode: addFile[0].code },
              });
            } else {
              this.utils.messageInfo(this, "error", "稿件不存在！");
            }
          } else {
            this.utils.messageInfo(this, "error", "查询稿件失败！");
          }
        });
    },
    dealHistory(record) {
      this.axios
        .get("/dealLog/queryDealLog", {
          params: {
            code: record.code,
            time: new Date().getTime(),
          },
          paramsSerializer: function (p) {
            return qs.stringify(p, { arrayFormat: "repeat" });
          },
        })
        .then((res) => {
          if (res.data.code == "OK") {
            this.dealList = res.data.data;
            this.dealVisible = true;
          } else {
            this.utils.messageInfo(this, "error", "查询处理历史失败！");
          }
        });
    },
    auditedOpinion(record) {
      this.manuscript = record;
      this.$refs.auditOpinions.show();
    },
    toBack(record) {
      var status = record.status;
      if (status == 4) {
        this.utils.messageInfo(this, "error", "当前状态不能撤稿！");
        return;
      }

      this.backCode = record.code;
      this.backVisible = true;
    },
    backOk() {
      this.axios
        .post("/manuscripts/changeStatus", [
          {
            code: this.backCode,
            status: 4,
            type: 1,
          },
        ])
        .then((res) => {
          if (res.data.code == "OK") {
            this.backVisible = false;
            this.utils.messageInfo(this, "success", "撤稿成功！");
            this.query();
          } else {
            this.utils.messageInfo(this, "error", "编辑失败！");
          }
        });
    },
    downLoad(record) {
      window.open(
        this.serviceAddress + "/manuscripts/downLoad?code=" + record.code
      );
    },
    manuscriptsInfo(record) {
      this.manuscript = record;
      this.$refs.manuscriptInfo.show();
    },
    onShowSizeChange(current, pageSize) {
      this.page = current;
      this.limit = pageSize;
      this.query();
    },
    pageChange(pageNumber) {
      this.page = pageNumber;
      this.query();
    },
    sortChange() {
      if (this.sort == 1) {
        this.sortField = "code";
        this.sortType = "desc";
      } else if (this.sort == 2) {
        this.sortField = "code";
        this.sortType = "";
      } else if (this.sort == 3) {
        this.sortField = "create_time";
        this.sortType = "desc";
      } else if (this.sort == 4) {
        this.sortField = "create_time";
        this.sortType = "";
      }
      this.query();
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    operateChange() {
      var itemLegth = this.selectedRowKeys.length;
      if (itemLegth == 0) {
        this.utils.messageInfo(this, "error", "最少选择一条数据！");
        return;
      }
      if (this.operateCode == 1) {
        if (this.serviceAddress == "") {
          this.utils.messageInfo(
            this,
            "error",
            "获取后台ip地址失败，无法导出！"
          );
          return;
        }
        var selectedRowKeys = this.selectedRowKeys;
        window.open(
          this.serviceAddress +
            "/manuscripts/exportData?codeArr=" +
            selectedRowKeys +
            "&type=1"
        );
      }
    },
    query() {
      this.axios
        .get("/manuscripts/queryQuery", {
          params: {
            code: this.queryCode,
            cnTitle: this.queryCnTitle,
            authorName: this.queryAuthorName,
            queryStatus: this.queryStatus,
            sortField: this.sortField,
            sortType: this.sortType,
            page: this.page,
            limit: this.limit,
            time: new Date().getTime(),
          },
          paramsSerializer: function (p) {
            return qs.stringify(p, { arrayFormat: "repeat" });
          },
        })
        .then((res) => {
          if (res.data.code == "0") {
            this.total = res.data.count;
            for (let i = 0; i < res.data.data.length; i++) {
              if (res.data.data[i].repetitionRate === 0) {
                res.data.data[i].repetitionRate = "";
              }
            }
            this.data = res.data.data;
          } else {
            this.utils.messageInfo(this, "error", "查询稿件列表失败！");
          }
        });
    },
  },
};
</script>
<style>
@import "../../../../assets/css/PageCss.css";
</style>
<style scoped>
</style>
